module.exports = __webpack_public_path__ + "media/images/chat_bg_light_new-6a1d79e7038bbc065fa7f2ff1afd1bbf.jpg";